import { render, staticRenderFns } from "./searchbox.vue?vue&type=template&id=06f18926&scoped=true&"
import script from "./searchbox.vue?vue&type=script&lang=js&"
export * from "./searchbox.vue?vue&type=script&lang=js&"
import style0 from "./searchbox.vue?vue&type=style&index=0&id=06f18926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f18926",
  null
  
)

export default component.exports